module.exports = __webpack_public_path__ + "static/media/barcode.737ea448.png";